export default "__VITE_ASSET__Cn06jX1h__"